module.exports = __webpack_public_path__ + "img/83.17ef0230.jpg";